import axios from "axios";
import API_URLS from "./global_variables";
import globalData from "./global_data";
import FormData from "form-data";
import { triggerNotification } from "../components/common/notify";
const userData = localStorage.userData ? JSON.parse(localStorage.userData) : "";

// Sync all data
const syncAll = async () => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.COMPLETE_SYNC,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
    };

    const data = await axios.request(config);
    if (data.data.isError) {
      triggerNotification({
        type: 'infor',
        title: 'Success!',
        message: data.data.message,
      });
    }
    return data.status === 200 && data.data ? true : [];

  } catch (error) {

    console.error("error", error);
    return [];
  }
};

// Get all stores
const get_stores = async () => {

  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_STORES,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
    };

    const data = await axios.request(config);

    if (data.status === 200) {
      const mappedData = data.data.data.map((item) => {
        const properties = JSON.parse(item.properties);
        return {
          value: properties.key,
          label: properties.key,
          store_id: item.id,
          currency_symbol: item.currency_symbol
        };
      });
      mappedData.unshift({
        value: 'all',
        label: 'All',
        store_id: null,
      });

      globalData.store_list = mappedData;
      return mappedData;
    }

    return [];
  } catch (error) {
    return [];
  }
};

// Get frontend tabs (attributes)
const GetFrontendTabs = async () => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_FRONTEND_TABS,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
    };

    const data = await axios.request(config);

    if (data.status === 200) {
      const mappedData = data.data.data.map((item) => ({
        name: item.attribute_label,
        values: [""],
        max_size: item.max_size,
        min_size: item.min_size,
        is_required: item.is_required,
        attribute_element_type: item.attribute_element_type,
        attribute_key: item.attribute_key,
        id: item.id,
        store_id: item.store_id,
        info_text: item.info_text,
        attri_pattern: item.attri_pattern,
        values_data: item.values_data
      }));

      globalData.attribute_tree = mappedData;
      return mappedData;
    }

    return [];
  } catch (error) {
    return [];
  }
};

// Get SAP SKUs
const get_sap_skus = async () => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.SEARCH_PRODUCT_SAP_SKU,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
    };

    const data = await axios.request(config);

    if (data.status === 200 && data.data?.data?.length > 0) {
      const mappedData = data.data.data.map((item) => ({
        value: item.sap_sku,
        label: item.sap_sku,
        store_id: item.store_id,
        prod_count: item.prod_count,
        variant_count: item.variant_count,
        sap_msrp: item.sap_msrp,
        sap_sale: item.sap_sale,
        sap_sku: item.sap_sku,
        inventory_reserved: item.inventory_reserved,
        product_name: item.product_name,
      }));

      globalData.sap_sku_list = mappedData;
      return mappedData;
    }

    return [];
  } catch (error) {
    return [];
  }
};

// Get all category tree
const get_all_category_tree = async (store_id) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_ALL_CATAGORY_TREE,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
    };

    const data = await axios.request(config);

    if (data.status === 200) {
      globalData.all_cat_list = data.data.data;
      return data.data.data;
    }

    return [];
  } catch (error) {
    return [];
  }
};

// Upload image to GCP bucket
const upload_image_to_bucket = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.UPLOAD_TO_GCP_BUCKET,
      headers: { 'Content-Type': 'multipart/form-data', 'Authorization': userData.token },
      data: formData,
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      // triggerNotification({
      //   type: 'success',
      //   title: 'Success!',
      //   message: data.data.message,
      // });
      return data.data.data;
    }

    if (data.status === 200 && data.data.error) {
      triggerNotification({
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      });
    }

    return [];
  } catch (error) {
    console.error("error", error);
    triggerNotification({
      type: 'error',
      title: 'Error!',
      message: error.message,
    });
    return [];
  }
};

// Create new simple product
const create_simple_product = async (req_data) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.CREATE_BC_PRODUCT,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify(req_data),
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      let responsedata = await data.data.refreshed_data;
      let finaldataafterupdte = await mapped_all(responsedata)

      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
        data: finaldataafterupdte
      };
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      }
    }

    return [];
  } catch (error) {
    console.error("error", error);
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    }
    return [];
  }
};

// Update existing product
const update_product = async (req_data) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.UPDATE_BC_PRODUCT,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify(req_data),
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      let responsedata = await data.data.refreshed_data;
      let finaldataafterupdte = null
      if (responsedata) {
        finaldataafterupdte = await mapped_all(responsedata)
      }
      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
        data: finaldataafterupdte
      };
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      };
    }

    return [];
  } catch (error) {
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    }
  }
};

// Get BC SKUs
const get_bc_skus = async () => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.SEARCH_PRODUCT_BC_SKU,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
    };

    const data = await axios.request(config);

    if (data.status === 200 && data.data?.data?.length > 0) {
      const mappedData = data.data.data.map((item) => ({
        value: item.sku,
        label: item.sku,
        store_id: item.store_id,
        msrp: item.msrp,
        sale_price: item.sale_price,
        product_name: item.name,
        image: item.image,
        product_id: item.product_id,
        sku: item.sku,
        status: item.status,
        disabled: item.status ? false : true,
        className: item.status ? "" : "disabled_sku"
      }));

      globalData.bc_sku_list = mappedData;
      return mappedData;
    }

    return [];
  } catch (error) {
    return [];
  }
};

const updateBulkProductStatus = async (reqdata, active) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.UPDATE_BC_BULK_PRODUCT_STATUS,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify({ data: reqdata, active })
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      // triggerNotification({
      //   type: 'success',
      //   title: 'Success!',
      //   message: data.data.message,
      // });
      let responsedata = await data.data.refreshed_data;
      let finaldataafterupdte = await map_all_bulk(responsedata)



      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
        data: finaldataafterupdte
      };
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      };
    }


    return [];
  } catch (error) {
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    };
  }
};

const syncBulkInventory = async (reqdata) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.SYNC_INVENTODY,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify({ data: reqdata })
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
      }
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      }
    }

    return [];
  } catch (error) {
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    };
  }
};
const syncSAP = async () => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.SYNC_SAP,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token }
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      triggerNotification({
        type: 'success',
        title: 'Success!',
        message: data.data.message,
      });
      return data;
    }

    if (data.status === 200 && data.data.error) {
      triggerNotification({
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      });
    }

    return [];
  } catch (error) {
    triggerNotification({
      type: 'error',
      title: 'Error!',
      message: error.message,
    });
    return [];
  }
};

const create_gift_product = async (req_data) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.CREATE_GIFT_PRODUCT,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify(req_data),
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      let responsedata = await data.data.refreshed_data;
      let finaldataafterupdte = await map_all_bulk(responsedata)

      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
        data: finaldataafterupdte
      };
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      };
    }

    return [];
  } catch (error) {
    console.error("error", error);
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    }
  }
};
// Enrich
const update_enrich_product = async (req_data) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.UPDATE_ENRICH,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify(req_data),
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      // triggerNotification({
      //   type: 'success',
      //   title: 'Success!',
      //   message: data.data.message,
      // });
      let responsedata = await data.data.refreshed_data;
      let finaldataafterupdte = await map_all_bulk(responsedata)



      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
        data: finaldataafterupdte
      };
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      };
    }

    return [];
  } catch (error) {
    console.error("error", error);
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    }
  }
};
const add_attribute_value = async (req_data) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.ADD_ATTRIBUTE_VALUE,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify(req_data),
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      // triggerNotification({
      //   type: 'success',
      //   title: 'Success!',
      //   message: data.data.message,
      // });
      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
      };
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      };
    }

    return [];
  } catch (error) {
    console.error("error", error);
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    }
  }
};
const update_attribute = async (req_data) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.UPDATE_ATTRIBUTES,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify(req_data),
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      // triggerNotification({
      //   type: 'success',
      //   title: 'Success!',
      //   message: data.data.message,
      // });
      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
      };
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      };
    }

    return [];
  } catch (error) {
    console.error("error", error);
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    }
  }
};
const add_attributes = async (req_data) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.ADD_ATTRIBUTES,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify(req_data),
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      // triggerNotification({
      //   type: 'success',
      //   title: 'Success!',
      //   message: data.data.message,
      // });
      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
      };
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      };
    }

    return [];
  } catch (error) {
    return {
      type: 'error',
      title: 'Error!',
      message: error.response.data.error,
    }
  }
};
const bulk_price_update = async (req_data) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.BULK_PRICE_UPDATE,
      headers: { 'Content-Type': 'application/json', 'Authorization': userData.token },
      data: JSON.stringify(req_data),
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      // triggerNotification({
      //   type: 'success',
      //   title: 'Success!',
      //   message: data.data.message,
      // });
      let responsedata = await data.data.refreshed_data;
      let finaldataafterupdte = await map_all_bulk(responsedata)



      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
        data: finaldataafterupdte
      };
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      };
    }

    return [];
  } catch (error) {
    return {
      type: 'error',
      title: 'Error!',
      message: error.response.data.error,
    }
  }
};
const import_data = async (req_data) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.IMPOT_EXCEL,
      headers: { 'Content-Type': 'multipart/form-data', 'Authorization': userData.token },
      data: req_data
    };

    const data = await axios.request(config);

    if (data.status === 200 && !data.data.error) {
      return {
        type: 'success',
        title: 'Success!',
        message: data.data.message,
      }
    }

    if (data.status === 200 && data.data.error) {
      return {
        type: 'error',
        title: 'Error!',
        message: data.data.error,
      }
    }

    return [];
  } catch (error) {
    console.error("error", error);
    return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    };
  }
};
const mapped_all = async (responsedata) => {
  const bc_data = responsedata.bc_data, sap_data = responsedata.sap_data, store_data = responsedata.store_data, currency_data = responsedata.currency_data, variant_data = responsedata.variant_data,
    variant_options_data = responsedata.variant_options_data, modifier_data = responsedata.modifier_data, bundle_data = responsedata.bundle_data;
  let store_parsedata = JSON.parse(store_data.properties)
  let finaldataafterupdte = {}
  if (sap_data) {
    let finalmappeddata = null
    if (variant_data && variant_data.length > 0) {
      const variantarraylist = await variant_data.map(item => {
        
        let selectvari = sap_data && sap_data.length > 0 ? sap_data.find(itemsap => item.variant_sku === itemsap.sap_sku) : null
        return {
          id: item.id,
          store_id: store_data.id,
          bc_product_id: item.bc_product_id,
          variant_id: item.variant_id,
          variant_sku: item.variant_sku,
          variant_name: item.variant_name,
          variant_type: item.variant_type,
          variant_image: item.variant_image,
          variant_values: item.variant_values,
          variant_msrp: item.variant_msrp,
          variant_sale_price: item.variant_sale_price,
          variant_default_price: item.variant_default_price,
          weight: item.weight,
          width: item.width,
          height: item.height,
          depth: item.depth,
          inventory_available: item.inventory_available,
          inventory_warning_level: item.inventory_warning_level,
          purchasing_disabled: item.purchasing_disabled,
          options: item.options,
          created_at: item.created_at,
          updated_at: item.updated_at,
          sap_data: selectvari ? {
            sap_sku: selectvari.sap_sku,
            sap_msrp: selectvari.msrp_inc,
            sap_sale: selectvari.msrp_excl,
            sap_inventory: selectvari.inventory_reserved
          } : null
        }
      })
      if(sap_data && sap_data.length > 0){
        finalmappeddata = await sap_data.map(item => {
          let selectvari = variant_data.find(itemvari => itemvari.variant_sku === item.sap_sku)
          return {
            prod_id: bc_data.prod_id,
            key: item.id,
            bc_sku: bc_data.sku,
            sapSku: item.sap_sku,
            sapName: item.product_name,
            bc_name: bc_data.prod_name,
            sapCustomerNumber: store_data.sap_customer_number,
            sapPrice: `${currency_data.currency_symbol}${item.msrp_excl}`,
            sapMsrp: `${currency_data.currency_symbol}${item.msrp_inc}`,
            availableStock: item.inventory_available,
            reservedStock: item.inventory_reserved,
            bcSku: item.sap_sku,
            type: "Variant",
            active: selectvari.purchasing_disabled ? 0 : 1,
            store: store_parsedata.key, // static as per your example
            bcInventory: selectvari ? selectvari.inventory_available : 0,
            enrichment: bc_data.enrichment,  // every 5th is false
            lastUpdated: new Date(bc_data.updated_at).toLocaleString("en-GB"), // format date
            action: "Edit",
            variant_arr: variantarraylist,
            variant_data: {
              id: selectvari.id,
              prod_sku: bc_data.sku,
              prod_msrp: bc_data.prod_msrp,
              variant_id: selectvari.variant_id,
              is_purchase: selectvari.purchasing_disabled ? false : true,
              variant_sku: selectvari.variant_sku,
              prod_sale_price: bc_data.prod_sale_price,
              inventory_warning_level: selectvari.inventory_warning_level
            },
            variant_options: variant_options_data,
            prdouct_data: null,
            store_id: store_data.id,
            currency_symbol: currency_data.currency_symbol,
            custom_fields: JSON.parse(bc_data?.custom_fields),
            images: JSON.parse(bc_data.prod_img),
            categories: JSON.parse(bc_data.categories),
            modifier_data: modifier_data,
            subscription: selectvari.is_subscription ? "YES" : "NO",
            og_subscription_enabled: selectvari.og_subscription_enabled,
            bc_url: bc_data.bc_url
          }
        })
      }

    } else {
      finalmappeddata = {
        prod_id: bc_data.prod_id,
        key: sap_data.id,
        bc_sku: bc_data.sku,
        sapSku: sap_data.sap_sku,
        sapName: sap_data.product_name,
        bc_name: bc_data.prod_name,
        sapCustomerNumber: store_data.sap_customer_number,
        sapPrice: `${currency_data.currency_symbol}${sap_data.msrp_excl}`,
        sapMsrp: `${currency_data.currency_symbol}${sap_data.msrp_inc}`,
        availableStock: sap_data.inventory_available,
        reservedStock: sap_data.inventory_reserved,
        bcSku: sap_data.sap_sku,
        type: "Simple",
        active: bc_data.is_purchase,
        store: store_parsedata.key, // static as per your example
        bcInventory: bc_data.inventory_level,
        enrichment: bc_data.enrichment,  // every 5th is false
        lastUpdated: new Date(bc_data.updated_at).toLocaleString("en-GB"), // format date
        action: "Edit",
        variant_arr: null,
        variant_data: null,
        variant_options: null,
        prdouct_data: {
          id: bc_data.id,
          sku: bc_data.sku,
          images: JSON.parse(bc_data.prod_img),
          store_id: store_data.id,
          prod_msrp: bc_data.prod_msrp,
          categories: JSON.parse(bc_data?.categories || "[]"),
          custom_fields: JSON.parse(bc_data?.custom_fields || "[]"),
          product_id: bc_data.prod_id,
          is_purchase: bc_data.is_purchase,
          bc_product_type: bc_data.bc_product_type,
          inventory_level: bc_data.inventory_level,
          prod_sale_price: bc_data.prod_sale_price,
          inventory_tracking: bc_data.inventory_tracking
        },
        store_id: store_data.id,
        currency_symbol: currency_data.currency_symbol,
        custom_fields: JSON.parse(bc_data?.custom_fields),
        images: JSON.parse(bc_data.prod_img),
        categories: JSON.parse(bc_data.categories),
        modifier_data: modifier_data,
        subscription: bc_data.is_subscription ? "YES" : "NO",
        og_subscription_enabled: bc_data.og_subscription_enabled,
        bc_url: bc_data.bc_url,
        bundle_sap_Array: bundle_data ? bundle_data : []
      }

    }
    finaldataafterupdte = { ...finaldataafterupdte, sap_updated_data: await finalmappeddata ? finalmappeddata : {} }
  }

  if (bundle_data && bundle_data.length > 0) {
    const bundleMappedData = {
      key: bc_data.prod_id,
      prod_id: bc_data.prod_id,
      sapSku: sap_data ? sap_data.sap_sku : "NA",
      sapName: sap_data ? sap_data.sapName : "NA",
      sapCustomerNumber: sap_data ? store_data.sap_customer_number : "NA",
      sapPrice: sap_data ? `${currency_data.currency_symbol}${sap_data.sap_msrp}` : "NA",
      sapMsrp: sap_data ? `${currency_data.currency_symbol}${sap_data.sap_sale}` : "NA",
      availableStock: sap_data ? sap_data.inventory_available : "NA",
      reservedStock: sap_data ? sap_data.inventory_reserved : "NA",
      bcSku: bc_data.sku,
      bc_name: bc_data.prod_name,
      type: bc_data.bc_product_type,
      active: bc_data.is_purchase,
      store: store_parsedata.key, // static as per your example
      bcInventory: bc_data.inventory_level,
      subscription: bc_data.is_subscription, // static as per your example
      enrichment: bc_data.enrichment,  // every 5th is false
      lastUpdated: new Date(bc_data.updated_at).toLocaleString("en-GB"), // format date
      config: modifier_data.config,
      modifier_data: modifier_data,
      msrp: bc_data.prod_msrp,
      sale_price: bc_data.prod_sale_price,
      currency_symbol: currency_data.currency_symbol,
      custom_fields: JSON.parse(bc_data?.custom_fields),
      bc_url: bc_data.bc_url,
      categories: JSON.parse(bc_data.categories),
      images: JSON.parse(bc_data.prod_img),
      store_id: bc_data.store_id,
      og_subscription_enabled: bc_data.og_subscription_enabled
    }
    finaldataafterupdte = { ...finaldataafterupdte, bundle_updated_data: await bundleMappedData ? bundleMappedData : {} }

  }
  else if (variant_data.length === 0) {
    const finalmappeddata = await {
      prod_id: bc_data.prod_id,
      bc_name: bc_data.prod_name,
      key: bc_data.id,
      sapSku: sap_data ? sap_data.sap_sku : "NA",
      sapName: sap_data ? sap_data.product_name : "NA",
      sapCustomerNumber: store_data.sap_customer_number,
      sapPrice: sap_data?`${currency_data.currency_symbol}${sap_data?.msrp_excl}`:"NA",
      sapMsrp: sap_data?`${currency_data.currency_symbol}${sap_data?.msrp_inc}`:"Na",
      availableStock: sap_data ? sap_data.inventory_available : "NA",
      reservedStock: sap_data ? sap_data.inventory_reserved : "NA",
      bcSku: bc_data.sku,
      type: bc_data.bc_product_type,
      active: bc_data.is_purchase,
      store: store_parsedata.key, // static as per your example
      bcInventory: bc_data.inventory_level,
      subscription: bc_data.is_subscription ? "YES" : "NO", // static as per your example
      enrichment: bc_data.enrichment,  // every 5th is false
      lastUpdated: new Date(bc_data.updated_at).toLocaleString("en-GB"), // format date
      store_id: store_data.id,
      currency_symbol: currency_data.currency_symbol,
      bc_url: bc_data.bc_url,
      og_subscription_enabled: bc_data.og_subscription_enabled,
      prdouct_data: {
        prod_msrp: bc_data.prod_msrp,
        prod_sale_price: bc_data.prod_sale_price,
        categories: JSON.parse(bc_data?.categories || "[]"),
        images: JSON.parse(bc_data?.prod_img || "[]"),
        custom_fields: JSON.parse(bc_data?.custom_fields || "[]"),
        product_id: bc_data.prod_id
      }
    }
    finaldataafterupdte.simple_updated_data = finalmappeddata
  } else {
    const variantarraylist = variant_data.map(item => {
      let selectvari = sap_data && sap_data.length > 0 ? sap_data.find(itemsap => item.variant_sku === itemsap.sap_sku) : null
      return {
        id: item.id,
        store_id: store_data.id,
        bc_product_id: item.bc_product_id,
        variant_id: item.variant_id,
        variant_sku: item.variant_sku,
        variant_name: item.variant_name,
        variant_type: item.variant_type,
        variant_image: item.variant_image,
        variant_values: item.variant_values,
        variant_msrp: item.variant_msrp,
        variant_sale_price: item.variant_sale_price,
        variant_default_price: item.variant_default_price,
        weight: item.weight,
        width: item.width,
        height: item.height,
        depth: item.depth,
        inventory_available: item.inventory_available,
        inventory_warning_level: item.inventory_warning_level,
        purchasing_disabled: item.purchasing_disabled,
        og_subscription_enabled: item.og_subscription_enabled,
        options: item.options,
        created_at: item.created_at,
        updated_at: item.updated_at,
        sap_data: selectvari ? {
          sap_sku: selectvari.sap_sku,
          sap_msrp: selectvari.msrp_inc,
          sap_sale: selectvari.msrp_excl,
          sap_inventory: selectvari.inventory_reserved
        } : null
      }
    })
    const finalmappeddata = {
      bc_url: bc_data.bc_url,
      key: bc_data.id,
      bc_name: bc_data.prod_name,
      bcSku: bc_data.sku,
      prod_id: bc_data.prod_id,
      type: bc_data.bc_product_type,
      active: bc_data.is_purchase,
      store: store_parsedata.key, // static as per your example
      enrichment: bc_data.enrichment,  // every 5th is false
      lastUpdated: new Date(bc_data.updated_at).toLocaleString("en-GB"), // format date
      action: "Edit",
      variant_data: variantarraylist,
      variant_options: variant_options_data,
      store_id: store_data.id,
      currency_symbol: currency_data.currency_symbol,
      msrp: bc_data.prod_msrp,
      sale_price: bc_data.prod_sale_price,
      custom_fields: JSON.parse(bc_data?.custom_fields),
      images: JSON.parse(bc_data.prod_img),
      inventory_tracking: bc_data.inventory_tracking,
      categories: JSON.parse(bc_data.categories),
      og_subscription_enabled: bc_data.og_subscription_enabled
    }
    finaldataafterupdte.variant_updated_data = finalmappeddata
  }



  return finaldataafterupdte
}
const map_all_bulk = async (responsedataArray) => {
  try {
    const finalMappedResults = await Promise.all(
      responsedataArray.map(async (respItem) => {
        return await mapped_all(respItem);
      })
    );
    // Filter out any `null` or `undefined` if needed
    return finalMappedResults.filter(item => item !== null);
  } catch (err) {
    console.error("Error in map_all_bulk:", err);
    return [];
  }
};
const set_all_madded_data_to_variables = async (globalList, responsedata, is_new = false) => {
  try {
    if (responsedata.data) {
      let sapmapped = [], simplemapped = [], variantmapped = []
      // for sap tab
      if (globalList.sap_datalist && globalList.sap_datalist.length > 0) {
        if (responsedata.data.sap_updated_data && !Array.isArray(responsedata.data.sap_updated_data)) {
          sapmapped = globalList.sap_datalist.map(item => {
            return item.key === responsedata.data.sap_updated_data.key ? responsedata.data.sap_updated_data : item
          }
          );
        } else if (responsedata.data.sap_updated_data && Array.isArray(responsedata.data.sap_updated_data)) {
          sapmapped = globalList.sap_datalist.map(item => {
            let is_exist = responsedata.data.sap_updated_data.find(innitem => item.key === innitem.key)
            return is_exist ? is_exist : item
          }
          );
        }
      }

      //for simple tab
      if (globalList.simple_datalist && globalList.simple_datalist.length && responsedata.data.simple_updated_data) {
        if (!is_new) {
          simplemapped = globalList.simple_datalist.map(item => {
            return item.key === responsedata.data.simple_updated_data.key ? responsedata.data.simple_updated_data : item
          }
          );
        } else {
          globalList.simple_datalist.unshift(responsedata.data.simple_updated_data);
          simplemapped = [...globalList.simple_datalist];
        }
      }

      if (globalList.variant_datalist && globalList.variant_datalist.length > 0) {
        //for variant tab
        if (responsedata.data.variant_updated_data && !is_new) {
          variantmapped = await globalList.variant_datalist.map(item => {
            return item.key === responsedata.data.variant_updated_data.key ? responsedata.data.variant_updated_data : item
          }
          );
        } else if (responsedata.data.variant_updated_data && is_new) {
          await globalList.variant_datalist.unshift(responsedata.data.variant_updated_data);
          variantmapped = [...globalList.variant_datalist];
        }
      }

      // for bundle tab
      if (responsedata.data.bundle_updated_data && globalList.bundle_datalist && globalList.bundle_datalist.length > 0) {
        if (is_new) {
          globalList.bundle_datalist.unshift(responsedata.data.bundle_updated_data);
        } else if (Array.isArray(responsedata.data.bundle_updated_data)) {
          globalList.bundle_datalist = globalList.bundle_datalist.map(item => {
            let is_exist = responsedata.data.bundle_updated_data.find(innitem => item.key === innitem.key)
            return is_exist ? is_exist : item
          });
        } else {
          globalList.bundle_datalist = globalList.bundle_datalist.map(item => {
            return item.key === responsedata.data.bundle_updated_data.key ? responsedata.data.bundle_updated_data : item
          });
        }
      }
      return {
        ...globalList,
        sap_datalist: sapmapped && sapmapped.length > 0 ? sapmapped : globalList.sap_datalist,
        variant_datalist: variantmapped && variantmapped.length > 0 ? variantmapped : globalList.variant_datalist,
        simple_datalist: simplemapped && simplemapped.length > 0 ? simplemapped : globalList.simple_datalist,
        bundle_datalist: globalList.bundle_datalist && globalList.bundle_datalist.length > 0 ? globalList.bundle_datalist : []
      }
    } else {
      return false
    }
  } catch (error) {
    console.error("error", error);


    return false
  }
}
const set_all_madded_data_to_variables_bulk = async (globalList, responsedata, is_new = false) => {

  try {
    let sapmapped = await globalList.sap_datalist ? globalList.sap_datalist : [], simplemapped = globalList.simple_datalist ? globalList.simple_datalist : [], variantmapped = globalList.variant_datalist ? globalList.variant_datalist : []

    if (responsedata.data && responsedata.data.length > 0) {

      for (let i = 0; i < responsedata.data.length; i++) {
        const element = responsedata.data[i];
        if (is_new && !element?.sap_updated_data) {
          if (element.simple_updated_data && simplemapped.length > 0) {
            simplemapped.unshift(element.simple_updated_data);
          }
        } else {

          if (element.sap_updated_data && Array.isArray(element.sap_updated_data)) {
            sapmapped = await sapmapped.map(item => {
              let is_exist = element.sap_updated_data.find(innitem => item.key === innitem.key)
              return is_exist ? is_exist : item
            }
            );
          }
          else if (element.sap_updated_data && !Array.isArray(element.sap_updated_data)) {
            sapmapped = sapmapped.map(item => {
              return item.key === element.sap_updated_data.key ? element.sap_updated_data : item
            }
            );
          }
          if (element.simple_updated_data && Array.isArray(element.simple_updated_data)) {
            simplemapped = simplemapped.map(item => {
              let is_exist = element.simple_updated_data.find(innitem => item.key === innitem.key)
              return is_exist ? is_exist : item
            }
            );
          }
          if (element.variant_updated_data && Array.isArray(element.variant_updated_data)) {
            variantmapped = variantmapped.map(item => {
              let is_exist = element.variant_updated_data.find(innitem => item.key === innitem.key)
              return is_exist ? is_exist : item
            }
            );
          }
        }
      }
      // for sap tab
      return {
        ...globalList,
        sap_datalist: sapmapped && sapmapped.length > 0 ? sapmapped : globalList.sap_datalist,
        variant_datalist: variantmapped && variantmapped.length > 0 ? variantmapped : globalList.variant_datalist,
        simple_datalist: simplemapped && simplemapped.length > 0 ? simplemapped : globalList.simple_datalist
      }
    } else {
      return false
    }

  } catch (error) {
    console.error("error", error);

    return false
  }
}

const convertToSamplePromotionProduct = async (reqdata) => {
  console.log("reqdata", reqdata);
  
  if (!reqdata || !Array.isArray(reqdata) || reqdata.length === 0) {
    return {
      type: 'error',
      title: 'Error',
      message: 'No products selected for conversion'
    };
  }

  try {
    // Format data as array of objects with id and store
    const requestBody = reqdata.map(product => ({
      id: product.prod_id,
      store: product.store || "UAT"
    })).filter(item => item.id); // Filter out items without id
    console.log("requestBody====", requestBody);
    if (requestBody.length === 0) {
      return {
        type: 'error',
        title: 'Error',
        message: 'No valid product IDs found'
      };
    }

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.CONVERT_TO_SAMPLE_PROMOTION_PRODUCT,
      headers: { 
        'Content-Type': 'application/json', 
        'Authorization': userData.token 
      },
      data: JSON.stringify(requestBody)
    };

    const response = await axios.request(config);
    
    if (response.status === 200 && !response.data.error) {
      return {
        type: 'success',
        title: 'Success!',
        message: response.data.message || `Successfully converted ${requestBody.length} product(s) to Sample Promotion Product`,
        data: response.data
      };
    }

    return {
      type: 'error',
      title: 'Error',
      message: response.data?.error || 'Failed to convert products to Sample Promotion Product'
    };
  } catch (error) {
    console.error("error", error);
    return {
      type: 'error',
      title: 'Error',
      message: error.response?.data?.message || error.message || 'Failed to convert products to Sample Promotion Product'
    };
  }
}

const commonApi = {
  syncAll,
  get_stores,
  GetFrontendTabs,
  get_sap_skus,
  get_all_category_tree,
  upload_image_to_bucket,
  create_simple_product,
  update_product,
  get_bc_skus,
  updateBulkProductStatus,
  syncBulkInventory,
  syncSAP,
  create_gift_product,
  update_enrich_product,
  add_attribute_value,
  update_attribute,
  add_attributes,
  import_data,
  set_all_madded_data_to_variables,
  set_all_madded_data_to_variables_bulk,
  map_all_bulk,
  bulk_price_update,
  mapped_all,
  convertToSamplePromotionProduct
};

export default commonApi;
